module.exports = __webpack_public_path__ + "img/bullet-blue.ffd293c8.svg";